import React, { useState } from 'react'
import {
  ModalContainer,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  Heading,
  Button,
  Text,
  Box,
  InjectedModalProps,
} from '@pancakeswap/uikit'
import styled from 'styled-components'
import { useXrpl } from '../xrpl'

const StyledModalContainer = styled(ModalContainer)`
  max-width: 420px;
  width: 100%;
`

const WalletOption = styled(Button)`
  justify-content: space-between;
  width: 100%;
`

const WalletMeta = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const Availability = styled(Text)`
  font-size: 12px;
`

const WalletSelectModal: React.FC<InjectedModalProps> = ({ onDismiss }) => {
  const { wallets, connect, connecting } = useXrpl()
  const [error, setError] = useState<string | null>(null)

  return (
    <StyledModalContainer minWidth="320px">
      <ModalHeader>
        <ModalTitle>
          <Heading>Select a Wallet</Heading>
        </ModalTitle>
        <ModalCloseButton onDismiss={onDismiss} />
      </ModalHeader>
      <ModalBody>
        {wallets.map((wallet) => (
          <WalletOption
            key={wallet.id}
            variant="secondary"
            mb="12px"
            disabled={connecting || (!wallet.available && wallet.id !== 'gemwallet' && wallet.id !== 'xumm')}
            onClick={async () => {
              setError(null)
              try {
                await connect(wallet.id)
                onDismiss?.()
              } catch (connectError) {
                const message = connectError instanceof Error ? connectError.message : 'Wallet connection failed'
                setError(message)
                console.error(connectError)
              }
            }}
          >
            <WalletMeta>
              <Text bold>{wallet.name}</Text>
              <Text fontSize="12px" color="textSubtle">
                {wallet.description}
              </Text>
            </WalletMeta>
            <Availability color={wallet.available ? 'success' : wallet.id === 'xumm' ? 'warning' : 'textSubtle'}>
              {wallet.available ? 'Detected' : wallet.id === 'xumm' ? 'Setup required' : 'Unavailable'}
            </Availability>
          </WalletOption>
        ))}
        {error && (
          <Text fontSize="12px" color="failure">
            {error}
          </Text>
        )}
      </ModalBody>
    </StyledModalContainer>
  )
}

export default WalletSelectModal
